import AuthForm from '../../../../src/js/components/AuthForm';

class LoginForm extends AuthForm {}

document.addEventListener('DOMContentLoaded', () => {
	new LoginForm('.form-user--login');
});
